import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { doc, setDoc, increment, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase/config';

const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const trackPageView = async () => {
      try {
        const pagePath = location.pathname;
        const pageRef = doc(db, 'analytics', 'pageViews');
        
        // Update page view count
        await setDoc(pageRef, {
          [`pages.${pagePath.replace(/\//g, '_')}`]: increment(1),
          lastUpdated: serverTimestamp()
        }, { merge: true });
        
      } catch (error) {
        console.error('Error tracking page view:', error);
      }
    };

    trackPageView();
  }, [location]);
};

export default usePageTracking;
